import { successCodeWith0Request as request } from '../request'

export function getImportTemplate() {
  return request.get('/wenjuan/projectBrief/staffImportTemplate', {
    responseType: 'blob'
  })
}

export function uploadBriefFile(projectId, briefType, file) {
  const fd = new FormData()
  fd.append('file', file)
  fd.append('briefType', briefType)
  fd.append('projectId', projectId)
  return request.post('/wenjuan/projectBrief/staffImport', fd, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

export function getAttachments(projectId, briefType, query = {}) {
  return request.get('/wenjuan/projectBrief/staffPage', {
    params: { projectId, briefType, ...query }
  })
}

export function updateBriefConfig(projectId, briefId, briefType, config = {}) {
  return request.post('/wenjuan/projectBrief/briefEdit', Object.assign({}, { projectId, briefId, briefType }, config))
}

export function getBriefConfig(projectId, briefType) {
  return request.get('/wenjuan/projectBrief/brief', {
    params: { projectId, briefType }
  })
}

// 分页查询签署进度
export function getSignPage(params) {
  return request.get('/wenjuan/projectBrief/signPage', {
    params
  })
}

// 任务书签署进度数量统计
export function getSignCount(projectId, briefType) {
  return request.get('/wenjuan/projectBrief/signCount', {
    params: { projectId, briefType }
  })
}

// 单个/批量 删除进度
export function signBatchDel(data) {
  return request.post('/wenjuan/projectBrief/signBatchDel', data)
}

// 查看签署进度详情
export function signDetail(id) {
  return request.get('/wenjuan/projectBrief/signDetail?id=' + id)
}

// 导出多个知情同意书签署情况
export function signBatchExport(data) {
  return request.post('/wenjuan/projectBrief/signBatchExport', data)
}

// 导出单个知情同意书签署情况
export function signExport(id) {
  return request.get('/wenjuan/projectBrief/signExport?id='+id)
}